import React, { useEffect, useRef, useState } from "react";
import GridItem from "../../components/Grid/GridItem";
import { QRCodeSVG } from "qrcode.react";
import { Button, Grid, Typography, Box } from "@material-ui/core";
import { useReactToPrint } from "react-to-print";

const PurchaseBarcodes = (props) => {
  const componentRef = useRef();
  let { purchases } = props.location?.state || { purchases: [] };
  let [barcodes, setBarcodes] = useState([]);
  let [barcodeQuantity, setBarcodeQuantity] = useState(0);

  console.log("purr", barcodes)

  useEffect(() => {
    if (!purchases || purchases.length === 0) {
      console.warn("No purchases data available");
      setBarcodes([]);
      setBarcodeQuantity(0);
      return;
    }

    let barcodes = [];
    purchases.forEach((purchase) => {
      if (purchase.products && Array.isArray(purchase.products)) {
        purchase.products.forEach((product) => {
          const quantity = Number(product.quantity) || 0;
          // Create the correct number of barcode entries for each product (multiply by 2 for pairs)
          // for (let j = 0; j < quantity * 2; j++) {
          barcodes.push(product);
          barcodes.push(product);
          // }
        });
      }
    });

    setBarcodes(barcodes);
    setBarcodeQuantity(barcodes.length);
    console.log("Total barcodes to print:", barcodes.length);
  }, [purchases]);


  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    pageStyle: ` 
    @media print {  
        html, body { margin: 0; padding: 0; }
        @page {
            size: 302px 94px;
            margin: 0mm;
            padding: 0mm;
            font-size: 14px;
        } 
        .qr-label {
            /* Chrome printers often clip a few pixels on the right.
               Keep label slightly smaller than @page to avoid cut-offs. */
            width: 296px;
            height: 92px;
            box-sizing: border-box;
            padding: 6px 18px 6px 10px; /* extra right padding prevents QR clipping */
            page-break-after: always;
            page-break-inside: avoid;
            overflow: hidden;
            font-family: Arial, sans-serif;
        }
        .qr-label svg {
            shape-rendering: crispEdges;
        }
        .qr-label:last-child {
            page-break-after: auto;
        }
    }`,
  });

  if (!purchases || purchases.length === 0) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <Typography variant="h6" color="error" style={{ marginBottom: '20px' }}>
          No purchase data available
        </Typography>
        <Typography variant="body1">
          Please go back to the Purchase List and select purchases to print QR codes.
        </Typography>
      </div>
    );
  }

  return (
    <div>
      <Button color="primary" onClick={handlePrint} disabled={!barcodes || barcodes.length === 0}>
        Print QR Codes ({barcodes.length} items)
      </Button>
      <div ref={componentRef}>
        {barcodes.map((i, index) => {
          // return (
          //   <>
          //     <GridItem xs={12} md={12} sm={12} style={{ width: 300 }}>

          //       <Barcode value={i.productCode} height={24} width={1} fontSize={11} />

          //       <GridItem xs={12} md={12} sm={12} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: 300 }}>
          //         <GridItem xs={1} sm={1} md={1} >
          //           {/* <Typography style={{ fontSize: "12px" }}>SPH</Typography> */}
          //         </GridItem>
          //         <GridItem xs={2} sm={2} md={2} >
          //           <Typography style={{ fontSize: "12px" }}><b>SPH</b></Typography>
          //         </GridItem>
          //         <GridItem xs={2} sm={2} md={2}>
          //           <Typography style={{ fontSize: "12px" }}><b>CYL</b></Typography>
          //         </GridItem>
          //         <GridItem xs={2} sm={2} md={2}>
          //           <Typography style={{ fontSize: "12px" }}><b>AXIS</b></Typography>
          //         </GridItem>
          //         <GridItem xs={2} sm={2} md={2}>
          //           <Typography style={{ fontSize: "12px" }}><b>ADD</b></Typography>
          //         </GridItem>
          //         <GridItem xs={2} sm={2} md={2}>
          //           <Typography style={{ fontSize: "12px" }}><b>SIDE</b></Typography>
          //         </GridItem>

          //       </GridItem>
          //       <GridItem xs={12} md={12} sm={12} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: 300 }}>
          //         <GridItem xs={1} sm={1} md={1} >
          //           {/* <Typography style={{ fontSize: "12px" }}>SPH</Typography> */}
          //         </GridItem>
          //         <GridItem xs={2} sm={2} md={2} >
          //           <Typography style={{ fontSize: "12px" }}><b>{i.sph}</b></Typography>
          //         </GridItem>
          //         <GridItem xs={2} sm={2} md={2}>
          //           <Typography style={{ fontSize: "12px" }}><b>{i.cyl}</b></Typography>
          //         </GridItem>
          //         <GridItem xs={2} sm={2} md={2}>
          //           <Typography style={{ fontSize: "12px" }}><b>{i.axis}</b></Typography>
          //         </GridItem>
          //         <GridItem xs={2} sm={2} md={2}>
          //           <Typography style={{ fontSize: "12px" }}><b>{i.addition}</b></Typography>
          //         </GridItem>
          //         <GridItem xs={2} sm={2} md={2}>
          //           <Typography style={{ fontSize: "12px" }}><b>{i.side}</b></Typography>
          //         </GridItem>

          //       </GridItem>
          //       <Box xs={12} md={12} sm={12} style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', width: 300 }}>
          //         <Typography variant="bold" style={{ fontSize: "13px" }}><b>{i.productName}</b></Typography>
          //       </Box>
          //     </GridItem>
          //   </>
          // );
          return (
            <div className="qr-label" key={index}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                <div style={{ flex: 1, paddingRight: 8 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", fontWeight: 800, fontSize: 9 }}>
                    <div style={{ width: 42, textAlign: "center" }}>SPH</div>
                    <div style={{ width: 42, textAlign: "center" }}>CYL</div>
                    <div style={{ width: 42, textAlign: "center" }}>AXIS</div>
                    <div style={{ width: 42, textAlign: "center" }}>ADD</div>
                    <div style={{ width: 42, textAlign: "center" }}>SIDE</div>
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", fontWeight: 800, fontSize: 9, marginTop: 2 }}>
                    <div style={{ width: 42, textAlign: "center" }}>{i.sph || ""}</div>
                    <div style={{ width: 42, textAlign: "center" }}>{i.cyl || ""}</div>
                    <div style={{ width: 42, textAlign: "center" }}>{i.axis || ""}</div>
                    <div style={{ width: 42, textAlign: "center" }}>{i.addition || ""}</div>
                    <div style={{ width: 42, textAlign: "center" }}>{i.side || ""}</div>
                  </div>
                  <div style={{ fontWeight: 900, fontSize: 11, marginTop: 6, textAlign: "center", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                    {i.productName || "Unknown Product"}
                  </div>
                </div>
                <div style={{ width: 52, textAlign: "right", flex: "0 0 52px" }}>
                  <QRCodeSVG value={i.productCode || "NO-CODE"} width={46} height={46} marginSize={0} level="M" />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PurchaseBarcodes;
